'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const regions = Array.from(navigator.languages || []);
const dateFormat = new Intl.DateTimeFormat(regions);
const timeFormat = new Intl.DateTimeFormat(regions, {
  hour: "numeric",
  minute: "numeric"
});
function formatDate(value) {
  const date = value instanceof Date ? value : new Date(value);
  return dateFormat.format(date);
}
function formatTime(value) {
  const date = value instanceof Date ? value : new Date(value);
  return timeFormat.format(date);
}
function toUtc(value) {
  let utcDate = value.toString();
  if (utcDate.indexOf("Z") === -1) {
    utcDate = value + "Z";
  }
  return value instanceof Date ? utcDate : new Date(utcDate);
}
function formatDuration(duration) {
  const durationNum = parseInt(duration, 10);
  const hours = Math.floor(durationNum / 60);
  const mins = durationNum % 60;
  if (hours > 0) {
    return `${hours}h ${mins}m`;
  } else {
    return `${mins} mins`;
  }
}
function formatCurrency(amount, currency, decimals) {
  const currencyFormat = new Intl.NumberFormat(regions, {
    style: "currency",
    currency,
    minimumFractionDigits: decimals < 2 ? 0 : void 0,
    maximumFractionDigits: decimals
  });
  return currencyFormat.format(amount);
}

exports.formatCurrency = formatCurrency;
exports.formatDate = formatDate;
exports.formatDuration = formatDuration;
exports.formatTime = formatTime;
exports.toUtc = toUtc;
